'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EditOutlined = _interopRequireDefault(require('./lib/icons/EditOutlined'));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

var _default = _EditOutlined;
exports.default = _default;
module.exports = _default;